import axios from 'axios'
import router from '@/router'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000
})

// Request interceptor
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token')
      localStorage.removeItem('currentCompany')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

// Convenience wrappers
export const getKpis = (companyId, params = {}) =>
  api.get(`/kpis/${companyId}`, { params })

export const getKpiConfig = (companyId) =>
  api.get(`/kpis/${companyId}/config`)

export const updateKpiConfig = (companyId, config) =>
  api.put(`/kpis/${companyId}/config`, config)

export default api